import { Injectable } from '@angular/core';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { BehaviorSubject, filter, Observable, ReplaySubject } from 'rxjs';
import { CCETAccountInfo, CCETRoles } from '@shared';

@Injectable({
  providedIn: 'root',
})
export class AppAuthServiceService {
  private ready: ReplaySubject<boolean> = new ReplaySubject<boolean>();

  public isReady: Observable<boolean> = this.ready.asObservable();
  public account: Partial<CCETAccountInfo> = {};
  public isAdmin: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isLoggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(private broadcastService: MsalBroadcastService, private authService: MsalService) {
    this.broadcastService.inProgress$
      .pipe(filter((status: InteractionStatus) => status === InteractionStatus.None))
      .subscribe(() => {
        this.isUserLoggedIn();
        this.ready.next(true);
        this.ready.complete();
      });
  }

  private isUserLoggedIn(): void {
    const loggedIn: boolean = this.authService.instance.getAllAccounts().length > 0;

    this.isLoggedIn.next(loggedIn);

    if (loggedIn) {
      this.account = this.authService.instance.getAllAccounts()[0];

      if (this.account.idTokenClaims && this.account.idTokenClaims.roles) {
        const roles = this.account.idTokenClaims.roles;
        this.isAdmin.next(roles.some((role) => role === CCETRoles.admin));
      } else {
        this.isAdmin.next(false);
      }
    }
  }

  public logout(): void {
    this.authService.logoutRedirect({ postLogoutRedirectUri: `${window.location.origin}/login` });
  }
}
